// src/components/DisciplineProvisionsPanel.js
//
// T5 / D-3, D-13 (2026-10-15): the case's own agreement on discipline, in its own words, by phase - the charge (the
// source for a specificity objection, D-3), the hearing (the hearing-day checklist, D-13), and what follows. Every line
// is a verbatim quote from the rule map with its file:line (src\data\disciplineProvisionsFor.js). Read-only; the tick
// boxes are a working aid on this screen and are not saved.
import React, { useState } from 'react';
import { provisionsFor } from '../data/disciplineProvisionsFor';
import { activate } from '../data/a11yActivate';   // pass 2: role, tabIndex and Enter/Space from one tested helper

const C = { line: '#2E4A6B', dim: '#8AA4BF', text: '#DCE7F2', accent: '#E8A020' };

export default function DisciplineProvisionsPanel({ disciplineCase }) {
  const k = disciplineCase || {};
  const p = provisionsFor(k.applicableAgreement);
  const [open, setOpen] = useState({ charge: true, hearing: true });
  return (
    <div className="card" style={{ marginBottom: 16 }}>
      <div className="card-title">What the agreement says - charge, hearing and after</div>
      <div className="card-subtitle" style={{ marginBottom: 8 }}>
        The agreement's own words, each with the file and line it is quoted from. Use the hearing section as the checklist: if a provision is not met, object on the record. The tick boxes are not saved.
      </div>
      {!p.bridged ? (
        <div style={{ fontSize: 12, color: C.accent }}>
          The agreement on this case ({k.applicableAgreement || 'none named'}) is not linked to the provision catalogue, so nothing is shown. This does not mean the agreement says nothing.
        </div>
      ) : p.groups.map(g => (
        <div key={g.key} style={{ marginBottom: 8 }}>
          <div style={{ cursor: 'pointer', fontSize: 12, fontWeight: 700, color: C.text }} {...activate(() => setOpen(o => ({ ...o, [g.key]: !o[g.key] })))}>
            {open[g.key] ? '▾' : '▸'} {g.label} ({g.rows.length})
          </div>
          {open[g.key] ? g.rows.map((r, i) => (
            <div key={i} style={{ padding: '4px 0 4px 14px', borderBottom: '1px dotted ' + C.line, fontSize: 12 }}>
              {g.key === 'hearing' ? <input type="checkbox" aria-label="checked at the hearing" style={{ marginRight: 6 }} /> : null}
              <span style={{ color: C.text }}>&ldquo;{r.quote}&rdquo;</span>
              <div style={{ fontSize: 10, color: C.dim }}>{r.rule} - {r.id} - {r.cite}</div>
            </div>
          )) : null}
        </div>
      ))}
    </div>
  );
}
